import { PriceUpdateAPIResponse } from '@/types/stores.types';
import { Grid, Typography } from '@mui/material';
import { t } from 'i18next';
import _ from 'lodash';
import { AlertCircle, CheckCircle, Info } from 'react-feather';
import { Link } from 'react-router-dom';

const FAILED = 'FAILED';

export enum EntityToUpdate {
  'MENU' = 'MENU',
  'BUNDLE_UC' = 'BUNDLE_UC',
  'BUNDLE_UC_STORE_GROUPS' = 'BUNDLE_UC_STORE_GROUPS',
}

function splitArray(toSplit: any[] = []) {
  const middleIndex = Math.ceil(toSplit.length / 2);
  const firstHalf = toSplit.slice(0, middleIndex);
  const secondHalf = toSplit.slice(middleIndex);
  return [firstHalf, secondHalf];
}

export const EditDrawerSuccessAndFailure = ({
  apiResponse,
  entityToUpdate,
}: {
  apiResponse: PriceUpdateAPIResponse;
  entityToUpdate: string;
}) => {
  const [failedStoresOne, failedStoresTwo] = splitArray(apiResponse?.failedStores);
  return apiResponse.successStoresCount === 0 ? (
    <Grid
      container
      direction={{ xs: 'column', sm: 'column', md: 'row', lg: 'row' }}
      justifyContent="flex-start"
      alignItems="center"
    >
      <Grid container direction="row" md={6}>
        <Grid container direction="row" justifyContent="flex-start" alignItems="center">
          <Grid item>
            <AlertCircle color="var(--red-700)" />
          </Grid>
          <Grid item>
            <Typography fontSize="2.0rem" fontWeight={700} pl={1} data-testid="totalFailure">
              {t(
                entityToUpdate === EntityToUpdate.MENU
                  ? 'editMenuPrice.allMenusFailedTitle'
                  : 'bundleUpcharges.editDrawer.allStoresFailed',
              )}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="column" pt={1}>
          <Grid item fontSize="2.0rem">
            {t('common.tryAgain')}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  ) : (
    <Grid
      container
      direction={{ xs: 'column', sm: 'column', md: 'row', lg: 'row' }}
      justifyContent="flex-start"
      alignItems="center"
    >
      <Grid container direction="row" md={6}>
        <Grid container direction="row" justifyContent="flex-start" alignItems="center">
          <Grid item>
            <CheckCircle color="var(--green-500)" />
          </Grid>
          <Grid item>
            <Typography fontSize="2.0rem" fontWeight={700} pl={1} data-testId="partialSuccess">
              {entityToUpdate === EntityToUpdate.MENU
                ? t('editMenuPrice.menusUpdated', { count: apiResponse.successStoresCount })
                : t('bundleUpcharges.editDrawer.storesUpdated', { count: apiResponse.successStoresCount })}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="column" pt={1}>
          <Grid item fontSize="2.0rem">
            {t('common.submissionPendingRequestDisclaimer')}
            <Typography component="span" fontSize="2.0rem">
              {t('common.calendar.menuDownloadTimeline')}
            </Typography>
          </Grid>
          <Grid item>
            <Typography component="p" fontSize="2.0rem">
              {t('common.calendar.check')}
              <Link to="/calendar" style={{ textDecoration: 'none' }}>
                <Typography
                  component="span"
                  fontSize="2.0rem"
                  fontWeight="600"
                  color="var(--blue-700)"
                  p={0.7}
                  sx={{ textDecoration: 'auto' }}
                >
                  {t('common.calendar.calendar')}
                </Typography>
              </Link>
              {t('common.calendar.forBlackouts')}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      {apiResponse.status === FAILED && (
        <Grid container direction="row" md={6}>
          <Grid container direction="row" justifyContent="flex-start" alignItems="center" pt={2}>
            <Grid item>
              <Info color="var(--red-700)" />
            </Grid>
            <Grid item>
              <Typography fontSize="2.0rem" component="span" fontWeight={700} pl={1}>
                {entityToUpdate === EntityToUpdate.MENU
                  ? t('editMenuPrice.menusFailed', { count: apiResponse?.failedStores.length })
                  : t('bundleUpcharges.editDrawer.storesFailed', { count: apiResponse?.failedStores.length })}
              </Typography>
            </Grid>
          </Grid>
          <Grid container direction="row" pl={2.5} pt={1}>
            <Grid item data-testid="partialFailure">
              <ul style={{ listStyle: 'unset', fontSize: '1.5em' }}>
                {failedStoresOne.map((failedStore) => (
                  <li key={failedStore}>
                    <Typography component="p" fontSize="1.8rem" pl={0}>
                      {failedStore}
                    </Typography>
                  </li>
                ))}
              </ul>
            </Grid>
            <Grid item direction="column" pl={5}>
              <ul style={{ listStyle: 'unset', fontSize: '1.5em' }}>
                {failedStoresTwo.map((failedStore) => (
                  <li key={failedStore}>
                    <Typography component="p" fontSize="1.8rem" pl={0}>
                      {failedStore}
                    </Typography>
                  </li>
                ))}
              </ul>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};
